import { AssetClass } from '__generated__/globalTypes';
const STORAGE_KEY = 'orsnn:lastPooledCandidate';

export type LastPooledCandidate = {
  tapeId: string;
  tapeName: string;
  assetClass: AssetClass;
  persistedAt: number;
  dismissedOnTable?: boolean;
};

const isCandidate = (value: unknown): value is LastPooledCandidate => {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.tapeId === 'string' &&
    typeof v.tapeName === 'string' &&
    typeof v.assetClass === 'string' &&
    typeof v.persistedAt === 'number'
  );
};

export const readPoolCandidate = (): LastPooledCandidate | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!isCandidate(parsed)) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const writePoolCandidate = (candidate: LastPooledCandidate): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(candidate));
  } catch {
    // sessionStorage unavailable (Safari private mode, restricted contexts).
    // Feature degrades silently — the CTA simply won't reappear after navigation.
  }
};

export const clearPoolCandidate = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};

export const dismissPoolCandidateOnTable = (): void => {
  const current = readPoolCandidate();
  if (!current) return;
  writePoolCandidate({ ...current, dismissedOnTable: true });
};
